"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printBridgeSuccess = exports.printBridgeSitePreview = exports.printBridgeSiteDownload = exports.printBridgeReset = exports.printBridgeReportPreview = exports.printBridgeReportDownload = exports.printBridgePaletteList = exports.printBridgeError = exports.printBridgeContentPanelPreview = exports.printBridgeContentPanelDownload = void 0;
var _printBridge = require("./printBridge.constant");
// @flow

// common success
var printBridgeSuccess = function printBridgeSuccess(actionType, data) {
  return {
    type: _printBridge.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.printBridgeSuccess = printBridgeSuccess;
var printBridgeError = function printBridgeError(actionType, error) {
  return {
    type: _printBridge.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to print data.
 */
exports.printBridgeError = printBridgeError;
var printBridgeSiteDownload = function printBridgeSiteDownload(data) {
  return {
    type: _printBridge.actionTypes.SITE_DOWNLOAD,
    payload: data
  };
};

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to print data.
 */
exports.printBridgeSiteDownload = printBridgeSiteDownload;
var printBridgePaletteList = function printBridgePaletteList(data) {
  return {
    type: _printBridge.actionTypes.PALETTE_LIST,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to preview data.
 */
exports.printBridgePaletteList = printBridgePaletteList;
var printBridgeSitePreview = function printBridgeSitePreview(data) {
  return {
    type: _printBridge.actionTypes.SITE_PREVIEW,
    payload: data
  };
};

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to print data.
 */
exports.printBridgeSitePreview = printBridgeSitePreview;
var printBridgeReportDownload = function printBridgeReportDownload(data) {
  return {
    type: _printBridge.actionTypes.REPORT_DOWNLOAD,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to preview data.
 */
exports.printBridgeReportDownload = printBridgeReportDownload;
var printBridgeReportPreview = function printBridgeReportPreview(data) {
  return {
    type: _printBridge.actionTypes.REPORT_PREVIEW,
    payload: data
  };
};

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to print data.
 */
exports.printBridgeReportPreview = printBridgeReportPreview;
var printBridgeContentPanelDownload = function printBridgeContentPanelDownload(data) {
  return {
    type: _printBridge.actionTypes.CONTENT_PANEL_DOWNLOAD,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to preview data.
 */
exports.printBridgeContentPanelDownload = printBridgeContentPanelDownload;
var printBridgeContentPanelPreview = function printBridgeContentPanelPreview(data) {
  return {
    type: _printBridge.actionTypes.CONTENT_PANEL_PREVIEW,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.printBridgeContentPanelPreview = printBridgeContentPanelPreview;
var printBridgeReset = function printBridgeReset() {
  return {
    type: _printBridge.actionTypes.RESET
  };
};
exports.printBridgeReset = printBridgeReset;